import { c as _c } from "react/compiler-runtime";
import { alpha, styled } from '@classify/react-core-components/styles';
import Typography from '@classify/react-core-components/Typography';
const Wrapper = styled('div')(({
  theme: {
    palette,
    spacing
  }
}) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  width: '100%',
  height: '100%',
  transform: 'translate(-50%, -50%)',
  backgroundColor: alpha(palette.layout.background.main, 0.86),
  pointerEvents: 'none',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: spacing(2),
  zIndex: 1
}));
const Content = styled(Typography)(() => ({
  textAlign: 'center',
  height: 'auto'
}));
const OverlayWrapper = t0 => {
  const $ = _c(4);
  let otherProps;
  if ($[0] !== t0) {
    ({
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = otherProps;
  } else {
    otherProps = $[1];
  }
  let t1;
  if ($[2] !== otherProps) {
    t1 = <Wrapper><Content {...otherProps} /></Wrapper>;
    $[2] = otherProps;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
export default OverlayWrapper;